// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a9b72094","93":"580da2b7","122":"b494447e","170":"9b3eba3e","267":"f717a33f","323":"31b0cc6f","335":"732ed4b2","336":"a81ad591","368":"37154e61","404":"93ff14bd","495":"dc30b7b0","674":"f6dcd8b2","731":"c3f1fbdb","735":"c04aaa90","856":"0438ca85"}[chunkId] + ".chunk.js";
};